import React from "react";

import { Stack, Typography } from "@mui/material";

import { ReactComponent as PdfIcon } from "../../../assets/icons/pdf.svg";
import { AddFilesButton } from "../AddFilesButton/AddFilesButton";

interface Props {
  onLoadFiles: (files: File[]) => void;
}

const EmptyDocumentView = ({ onLoadFiles }: Props) => {
  return (
    <Stack justifyContent="center" alignItems="center" gap="30px" sx={{ width: "100%" }}>
      <PdfIcon style={{ height: 80 }} />
      <Stack>
        <Typography sx={{ textAlign: "center" }}>Nothing here yet. Once you</Typography>
        <Typography sx={{ textAlign: "center" }}>upload a PDF, it will appear here.</Typography>
      </Stack>
      <AddFilesButton onLoadFiles={onLoadFiles} />
    </Stack>
  );
};

export default EmptyDocumentView;
